import React from "react";

const checkInOutRequest = () => {
  return <div>checkInOutRequest</div>;
};

export default checkInOutRequest;
